module.exports = __webpack_public_path__ + "static/media/AdiLAT.221fda43.pdf";